var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"metrics"},[_c('div',{staticClass:"card"},[_c('p',{staticClass:"amount"},[_vm._v(_vm._s(_vm.data.value))]),_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.data.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }